import ProfitLossHTMLPreviewBaseSection from './ProfitLossHTMLPreviewBaseSection'
import {ReportGroupingLevel} from '../../../constants'

export default function ProfitLossHTMLPreviewGroupingSection () {}

ProfitLossHTMLPreviewGroupingSection.prototype = new ProfitLossHTMLPreviewBaseSection();

ProfitLossHTMLPreviewGroupingSection.prototype.init = function ( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, groupingRowsCount )
{
    ProfitLossHTMLPreviewBaseSection.prototype.init.call( this, columnsStrategy );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.groupingRowsCount = groupingRowsCount;
    return this;
};

ProfitLossHTMLPreviewGroupingSection.prototype.addRows = function( tBody )
{
    this.addRowWithMainCell( tBody, this.message( "report.profit_loss.total_for_working_time" ), "totalForWorkingTime", "totalForWorkingTimeRow" );

    var rowsCount = 0;
    while( true )
    {
        this.addGroupingRow( tBody, this.firstGroupingLevel, "firstLevel", "firstGrouping" );
        if( ++rowsCount >= this.groupingRowsCount ) break;

        if( this.secondGroupingLevel != ReportGroupingLevel.NONE )
        {
            this.addGroupingRow( tBody, this.secondGroupingLevel, "secondLevel", "secondGrouping" );
            if( ++rowsCount >= this.groupingRowsCount ) break;
        }

        if( this.thirdGroupingLevel != ReportGroupingLevel.NONE )
        {
            this.addGroupingRow( tBody, this.thirdGroupingLevel, "thirdLevel");
            if( ++rowsCount >= this.groupingRowsCount ) break;
            this.addGroupingRow( tBody, this.thirdGroupingLevel, "thirdLevel");
            if( ++rowsCount >= this.groupingRowsCount ) break;
        }
    }
};

ProfitLossHTMLPreviewGroupingSection.prototype.addGroupingRow = function( tBody, groupingLevel, mainCellClassName, rowClassName )
{
    this.addRowWithMainCell( tBody, ReportPreviewUtils.getLevelPreviewName( groupingLevel ), mainCellClassName, rowClassName );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewGroupingSection.js